import { createBrowserRouter } from 'react-router'

import Index from './pages/Index'
import Notfound from './pages/Notfound'
import Auth from './pages/Auth'
import UserPage from './pages/User'
import HistoryPage from './pages/History'
import ProtectedRoute from './components/Common/ProtectedRoute'
import SettingsPage from './pages/Settings'
import ChatDetailPage from './pages/ChatDetail'
import Welcome from './pages/Welcome'
import Module2Page from './pages/Module2/Module2Page'
import OrganizationBasedRoute from './components/Common/OrganizationBasedRoute'
import DashboardPage from './pages/Dashboard'
import CoachPage from './pages/Coach'
import PartnerOnboardingComplete from './pages/PartnerOnboardingComplete'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <OrganizationBasedRoute />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/coach',
    element: (
      <ProtectedRoute>
        <CoachPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/user',
    element: (
      <ProtectedRoute>
        <UserPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/history',
    element: (
      <ProtectedRoute>
        <HistoryPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/chat/:chatId',
    element: (
      <ProtectedRoute>
        <ChatDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/auth',
    element: <Auth />,
  },
  {
    path: '/welcome',
    element: (
      <ProtectedRoute>
        <Welcome />
      </ProtectedRoute>
    ),
  },
  {
    path: '/module2',
    element: (
      <ProtectedRoute>
        <Module2Page />
      </ProtectedRoute>
    ),
  },
  {
    // Public: the partner who lands here after Stripe onboarding has no Georgia account.
    path: '/partner/onboarding-complete',
    element: <PartnerOnboardingComplete />,
  },
  {
    path: '*',
    element: <Notfound />,
  },
])

export default router
